module.exports = __webpack_public_path__ + "img/beneficio_4.f79c0936.webp";